/**
 * userSignatureController — UI-facing handle for saving the BP's
 * reusable signature. Forwards to `userSignatureService` which does
 * the actual S3 upload + Cognito attribute write.
 */
import type { IUserSignatureServiceImpl } from "../../core/impl/userSignatureServiceImpl";

export const UserSignatureControllerFactory = ({
  userSignatureService,
}: {
  userSignatureService: IUserSignatureServiceImpl;
}): IUserSignatureController => ({
  saveUserSignature: async ({ userId, signatureData }) => {
    return userSignatureService.saveUserSignature({ userId, signatureData });
  },
});
